/**
 * F8 트레이닝: DPS, 최근 히트, 무적 토글 안내.
 */

import Phaser from 'phaser';
import { training } from '../systems/Training';
import { COLOR, TEXT_COLOR, UI_FONT } from './theme';

export class TrainingOverlay {
  private readonly box: Phaser.GameObjects.Container;
  private readonly body: Phaser.GameObjects.Text;

  constructor(scene: Phaser.Scene) {
    const w = 320;
    const x = 16;
    const y = 88;
    this.box = scene.add.container(x, y).setDepth(35).setScrollFactor(0).setVisible(false);

    const g = scene.add.graphics();
    g.fillStyle(COLOR.panelEdge, 0.88);
    g.fillRoundedRect(0, 0, w, 220, 8);
    this.box.add(g);

    this.body = scene.add.text(10, 8, '', {
      fontFamily: UI_FONT,
      fontSize: '13px',
      color: TEXT_COLOR.bright,
      wordWrap: { width: w - 20, useAdvancedWrap: true },
      lineSpacing: 3,
    });
    this.box.add(this.body);
  }

  refresh(): void {
    this.box.setVisible(training.on);
    if (!training.on) return;
    const lines = [
      '트레이닝  F8 닫기 · G 무적',
      `무적 ${training.god ? '켜짐' : '꺼짐'}`,
      `DPS(5초) ${training.dps().toFixed(1)}`,
      '',
      ...training.log.slice(0, 8).map((h) => {
        const who = h.toPlayer ? '피격' : h.name;
        return `${who} ${h.amount}${h.crit ? '!' : ''}`;
      }),
    ];
    this.body.setText(lines.join('\n'));
  }

  destroy(): void {
    this.box.destroy();
  }
}
